/* tslint:disable */
/* eslint-disable */
import { HttpClient, HttpContext, HttpResponse } from '@angular/common/http';
import { Observable } from 'rxjs';
import { filter, map } from 'rxjs/operators';
import { HealthFindrStrictHttpResponse } from '../../health-findr-strict-http-response';
import { RequestBuilder } from '../../request-builder';

import { BroadcastMessageSearchResultModel } from '../../models/broadcast-message-search-result-model';
import { ConfigSearchRequestModel } from '../../models/config-search-request-model';

export interface BroadcastMessageSearchPost$Params {
      body?: ConfigSearchRequestModel
}

export function broadcastMessageSearchPost(http: HttpClient, rootUrl: string, params?: BroadcastMessageSearchPost$Params, context?: HttpContext): Observable<HealthFindrStrictHttpResponse<Array<BroadcastMessageSearchResultModel>>> {
  const rb = new RequestBuilder(rootUrl, broadcastMessageSearchPost.PATH, 'post');
  if (params) {
    rb.body(params.body, 'application/*+json');
  }

  return http.request(
    rb.build({ responseType: 'json', accept: 'text/json', context })
  ).pipe(
    filter((r: any): r is HttpResponse<any> => r instanceof HttpResponse),
    map((r: HttpResponse<any>) => {
      return r as HealthFindrStrictHttpResponse<Array<BroadcastMessageSearchResultModel>>;
    })
  );
}

broadcastMessageSearchPost.PATH = '/BroadcastMessage/Search';
